var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExerciseVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_725_2624)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66675 16.0001C1.66675 8.084 8.084 1.66675 16.0001 1.66675C23.9162 1.66675 30.3334 8.084 30.3334 16.0001C30.3334 23.9162 23.9162 30.3334 16.0001 30.3334C8.084 30.3334 1.66675 23.9162 1.66675 16.0001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 1.16675C7.80786 1.16675 1.16675 7.80786 1.16675 16.0001C1.16675 24.1923 7.80786 30.8334 16.0001 30.8334C24.1923 30.8334 30.8334 24.1923 30.8334 16.0001C30.8334 7.80786 24.1923 1.16675 16.0001 1.16675Z",
    stroke: "url(#paint0_linear_725_2624)",
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0605 10.1466C16.6861 10.4542 17.445 10.9212 18.3743 11.4932L18.4623 11.5474C19.3926 12.1199 20.1512 12.5867 20.7131 13.0099C21.2836 13.4396 21.7782 13.9141 22.0437 14.5498C22.4299 15.4742 22.4299 16.5259 22.0437 17.4504C21.7782 18.086 21.2836 18.5605 20.7131 18.9902C20.1512 19.4134 19.3926 19.8802 18.4624 20.4527L18.3743 20.5069C17.445 21.0789 16.6861 21.5459 16.0605 21.8535C15.4317 22.1626 14.7771 22.3957 14.0881 22.3185C13.0922 22.2069 12.2081 21.6524 11.6428 20.823C11.2591 20.2602 11.1248 19.577 11.0623 18.8505C11 18.1262 11 17.1978 11 16.048V15.9522C11 14.8023 11 13.874 11.0623 13.1496C11.1248 12.4231 11.2591 11.74 11.6428 11.1771C12.2081 10.3477 13.0922 9.79321 14.0881 9.68164C14.7771 9.60444 15.4317 9.83756 16.0605 10.1466ZM14.3107 11.6692C14.4154 11.6575 14.6412 11.6775 15.1781 11.9415C15.7081 12.202 16.3859 12.6179 17.3706 13.2239C18.3549 13.8297 19.0323 14.2478 19.51 14.6075C19.9878 14.9674 20.1392 15.1791 20.1982 15.3206C20.3784 15.7518 20.3784 16.2483 20.1982 16.6795C20.1392 16.821 19.9878 17.0327 19.51 17.3926C19.0323 17.7524 18.3549 18.1705 17.3706 18.7762C16.3859 19.3823 15.7081 19.7981 15.1781 20.0586C14.6412 20.3226 14.4154 20.3426 14.3107 20.3309C13.9221 20.2874 13.5484 20.0678 13.2954 19.6966C13.21 19.5713 13.1097 19.3151 13.055 18.679C13.0009 18.0508 13 17.2091 13 16.0001C13 14.791 13.0009 13.9493 13.055 13.3211C13.1097 12.6851 13.21 12.4289 13.2954 12.3035C13.5484 11.9323 13.9221 11.7127 14.3107 11.6692Z",
    fill: "url(#paint1_linear_725_2624)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_725_2624",
    x: -23.3333,
    y: -23.3333,
    width: 78.6667,
    height: 78.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_725_2624"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_725_2624",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_725_2624",
    x1: 1.66675,
    y1: 1.66675,
    x2: 30.3479,
    y2: 30.3189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_725_2624",
    x1: 16.7621,
    y1: 25.0319,
    x2: 34.0982,
    y2: 9.82703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseVideo);
export default __webpack_public_path__ + "static/media/exercise-video.35864fa50671a3ad5861a545d70003f3.svg";
export { ForwardRef as ReactComponent };